import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 retrieve_specific_tenant_settings: { message: "idle" },
};

export const retrieve_specific_tenant_settings_Slice = createSlice({
 name: "retrieve_specific_tenant_settings",
 initialState,
 reducers: {
  success_retrieve_specific_tenant_settings: (state, action) => {
   state.retrieve_specific_tenant_settings = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_retrieve_specific_tenant_settings: (state, action) => {
   state.retrieve_specific_tenant_settings = { status: app_consts.FAIL, message: action.payload };
  },
  reset_retrieve_specific_tenant_settings: (state) => {
   state.retrieve_specific_tenant_settings = { status: app_consts.IDLE };
  },
  loading_retrieve_specific_tenant_settings: (state) => {
   state.retrieve_specific_tenant_settings = { status: app_consts.LOADING };
  },
 }
});

export const { success_retrieve_specific_tenant_settings, fail_retrieve_specific_tenant_settings, reset_retrieve_specific_tenant_settings, loading_retrieve_specific_tenant_settings } = retrieve_specific_tenant_settings_Slice.actions;

export default retrieve_specific_tenant_settings_Slice.reducer;